export default function ProductFor(productname) {
    switch(productname){
    case'IndexUniversalLife':
    return {
        title: "Who is this Product For?",
        heading:'Review your book of business for opportunities:',
        paragraphs:[ 'Clients at all life stages',
                     'On-track and at-risk clients in Goals Planning System',
                     'Have a high and stable cash flow',
                     'Have estate or business planning needs',
                     'Have children or other dependents who rely on their income to maintain their lifestyle',
                     'Are conservative with a moderate risk tolerance',
                     'Are looking for death benefit protection with cash value growth potential',
                    ],
        headingsecond:'Review your book of business for opportunities:',
        paragraphsecond:[
                    'Are you looking for a vehicle to provide protection for your family?',
                     'Are you concerned that you are paying too much in taxes?',
                     'Is it important to have flexibility to protect your family and access funds for retirement income?', 
                     ] 
        }
        case 'VariableUniversalLife':
            return {
                title: "Who is this Product For?",
                heading:'Review your book of business for opportunities:',
                paragraphs:[ `Clients at all life stages`,
                            `Clients on track`,
                            `Are between the ages of 25 and 75`,
                             `Have a high and stable cash flow`,
                             `Need to protect their family and also accumulate assets, or`,
                             `Have an estate or business planning objective`,
                             `Have a moderate to high risk tolerance`,
                            ],
                headingsecond:`Conversation Starters`,
                paragraphsecond:[
                    `Are you looking for a vehicle to provide protection for your family?`,
                    `Are you concerned that you are paying too much in taxes?`,
                    `Is it important to have flexibility to protect your family and access funds for retirement income?`
                ] 
            }
          case 'UniversalLife':
            return {
                title: "Who is this Product For?",
                heading:'Review your book of business for opportunities:',
                paragraphs:[ `Clients at all life stages`,
                             `On-track and at-risk clients in Goals Planning System`,
                             `Are over age 25`,
                             `Have a high and stable cash flow`,
                             `Have estate or business planning needs`,
                            `Have children or other dependents who rely on their income to maintain their lifestyle`,
                            `Are conservative with a moderate risk tolerance`
                            ],
                headingsecond:`Conversation Starters`,
                paragraphsecond:[
                           `Are you looking for a vehicle to provide protection for your family?`,
                            `Are you concerned that you are paying too much in taxes?`,
                            `Is it important to have flexibility to protect your family and access funds for retirement income?`
                            ] 
                 }
            case 'Wholelife':
                return {
                    title: "Who is this Product For?",
                    heading:'Review your book of business for opportunities:',
                    paragraphs:[ `Clients at all life stages`,
                                 `On-track and at-risk clients in Goals Planning System`,
                                 `Have a high and stable cash flow`,
                                 `Have estate or business planning needs`,
                                 `Have children or other dependents who rely on their income to maintain their lifestyle`,
                                 `Are conservative with a low risk tolerance`,
                                 `Are looking for death benefit protection with cash value growth potential `
                                ],
                    headingsecond:`Conversation Starters`,
                    paragraphsecond:[
                         `Is guaranteed permanent coverage important to you?`,
                         `Are you looking for a vehicle to provide protection for your family?`,
                         `Are you maxing out contributions to other qualified plans and seeking an additional vehicle to diversify your savings portfolio?`,
                    ] 
                 }
            default:
                return;
         }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/perm/ProductFor.js